const settings = {
  brandSite: true,
  channels: [
    {
      channel: 'Koskenkorva EN',
      locale: 'en-US',
      languageCode: 'en',
      slugs: {
        ContentfulArticlePage: 'article',
      },
    },
    {
      channel: 'Koskenkorva DE',
      locale: 'de-DE',
      languageCode: 'de',
      slugs: {
        ContentfulArticlePage: 'Artikel',
      },
    },
  ],
  localization: {
    default: 'en-US',
    defaultLanguageCode: 'en',
  },
};

export default settings;
